import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

/**
 * Apply to a `<Menu>`'s Paper — via `slotProps.paper.sx` or
 * `PaperProps.sx` — to force the dropdown to span the mobile viewport
 * (matches the Material-Design phone pattern where menus fill the page
 * width instead of anchoring to their trigger button).
 *
 * Overrides Popover's inline `left` value and sets an 8px gutter on each
 * side. Disabled at `md` and up so desktop keeps its intrinsic-width
 * anchored dropdowns.
 *
 * Typed as a plain callback returning a `SystemStyleObject` (not
 * `SxProps<Theme>`) so it can be safely composed inside an sx array, e.g.
 *
 *   sx={[{ borderRadius: 3, mt: 0.5 }, mobileFullWidthMenuPaperSx]}
 */
export const mobileFullWidthMenuPaperSx = (theme: Theme): SystemStyleObject<Theme> => ({
  [theme.breakpoints.down("md")]: {
    width: "calc(100vw - 16px) !important",
    maxWidth: "calc(100vw - 16px) !important",
    left: "8px !important",
    right: "auto !important",
    boxSizing: "border-box"
  }
});
